module.exports = __webpack_public_path__ + "img/right-arrow-white.5a22a5ac.svg";